import { useEffect } from 'react';
import { connect } from 'react-redux';
import { fetchCurrentStaff } from 'actions/navHeader';
import { customerLogout } from 'actions/customerList';
import { fetchBasket } from 'actions/basket';
import { fetchHomeWidget } from 'actions/homeWidget';

let _content = null;

const Home = (props) => {
  const {
    fetchCurrentStaff,
    customerLogout,
    fetchBasket,
    fetchHomeWidget,
    state,
  } = props;

  useEffect(() => {
    fetchBasket();
    fetchHomeWidget();
    fetchCurrentStaff();
    if (state) {
      if (state.newCustomer) {
        customerLogout();
      }
    }
  }, []);

  return (
    _content &&
    _content({
      props,
    })
  );
};

const mapStateToProps = (state) => {
  return {
    homeWidget: state.homeWidget.homeWidget,
    homeWidgetPending: state.homeWidget.pending,
    pending: state.widgets.pending,
    error: state.widgets.error,
    basket: state.basket.basketItems,
  };
};

const mapDispatchToProps = {
  fetchCurrentStaff,
  customerLogout,
  fetchBasket,
  fetchHomeWidget,
};

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(Home);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/home/index.js